import { FC } from 'react';

import { CenteredSpin } from '../common';

type Props = {
	isLoading: boolean;
};

/**
 * CenteredRelativeLoaderWithBlur
 *
 * Компонент отображает затемнение и спиннер поверх дочернего контента.
 * ВАЖНО: должен использоваться только внутри контейнера с CSS-свойством `position: relative`.
 * Иначе абсолютное позиционирование приведёт к некорректному отображению.
 *
 * @component
 * @param {boolean} isLoading - Флаг, показывающий, отображать ли спиннер.
 */

export const CenteredRelativeLoaderWithBlur: FC<Props> = ({ isLoading }) => {
	return (
		isLoading && (
			<div
				style={{
					position: 'absolute',
					top: 0,
					left: 0,
					width: '100%',
					height: '100%',
					backgroundColor: '#fff',
					zIndex: 1000,
					opacity: 0.5,
				}}
			>
				<CenteredSpin />
			</div>
		)
	);
};
